// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__1-jcg","tab":"ProcedureTabs_tab__2M3sT"};